var exports = {
  "Sh": "token__vR0Uhg",
  "as": "smallSummary__qZakmk",
  "T5": "visualLabel__f2CfxJ",
};

module.exports = exports;
